var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 81,
    viewBox: "0 0 62 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.233398 0.183594H28.1037C39.6526 0.183594 47.8862 1.90814 52.8045 5.35724C57.7228 8.80633 60.1819 13.7598 60.1819 20.2177C60.1819 23.7402 59.5444 26.7306 58.2693 29.189C57.0306 31.6474 55.4458 33.5921 53.5149 35.0231C51.6205 36.4541 49.6714 37.4265 47.6676 37.9402V38.4906C49.8535 39.041 52.0212 39.9583 54.1707 41.2425C56.3566 42.4901 58.16 44.3797 59.5808 46.9115C61.0381 49.4066 61.7667 52.8006 61.7667 57.0937C61.7667 61.9738 60.528 66.1751 58.0507 69.6975C55.6098 73.22 52.1123 75.9353 47.5583 77.8433C43.0043 79.7146 37.5942 80.6503 31.328 80.6503H0.233398V0.183594ZM21.8192 31.0603H28.3223C31.8926 31.0603 34.4064 30.3265 35.8637 28.8588C37.321 27.3544 38.0496 25.5381 38.0496 23.41C38.0496 21.2084 37.2117 19.5389 35.5358 18.4014C33.8964 17.2273 31.3462 16.6402 27.8851 16.6402H21.8192V31.0603ZM21.8192 46.9665V63.8634H29.4153C33.1678 63.8634 35.7908 63.0562 37.2846 61.4417C38.7783 59.7906 39.5251 57.7358 39.5251 55.2774C39.5251 53.8464 39.1972 52.5071 38.5415 51.2596C37.9221 49.9753 36.8474 48.9479 35.3172 48.1774C33.7871 47.3702 31.6741 46.9665 28.9781 46.9665H21.8192Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.47683335b63c241a7f6cb910890eea36.svg";
export { ForwardRef as ReactComponent };